<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>
    <!-- Back Icon (visible only if URL contains 'university-detail') -->
    <div class="back-icon-container">
      <b-link class="nav-link" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" size="21" />
      </b-link>
    </div>
    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <!-- Bookmarks Container -->
      <!-- <bookmarks /> -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-badge
        v-if="$store.state.user.unread_notifications_count"
        style="margin-right: 10px"
        pill
        variant="light-primary"
      >
        {{ $store.state.user.unread_notifications_count }} New
        Notifications</b-badge
      >
      <b-badge
        :to="{ name: 'chat' }"
        v-if="$store.state.user.unread_messages_count"
        style="margin-right: 10px"
        pill
        variant="light-secondary"
      >
        {{ $store.state.user.unread_messages_count }} New Messages</b-badge
      >
      <!-- <Locale /> -->
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
      <!-- <search-bar /> -->
      <!-- <cart-dropdown /> -->
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BBadge } from "bootstrap-vue";
import Bookmarks from "./components/Bookmarks.vue";
import Locale from "./components/Locale.vue";
import SearchBar from "./components/SearchBar.vue";
import DarkToggler from "./components/DarkToggler.vue";
import CartDropdown from "./components/CartDropdown.vue";
import NotificationDropdown from "./components/NotificationDropdown.vue";
import UserDropdown from "./components/UserDropdown.vue";
import BASEURL from './../../../../config/index'
export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    BBadge,
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
